"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateIcon = void 0;
const React = __importStar(require("react"));
const DateIcon = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 12, height: 13, fill: "none" }, props),
    React.createElement("path", { fill: "#1D3256", d: "M10.746 1.197H9.713V.663A.66.66 0 0 0 9.048 0a.66.66 0 0 0-.664.663v.534H3.606V.663A.66.66 0 0 0 2.942 0a.66.66 0 0 0-.664.663v.534H1.254C.563 1.197 0 1.749 0 2.43v9.326c0 .681.563 1.234 1.254 1.234h9.492c.691 0 1.254-.553 1.254-1.234V2.431c0-.682-.563-1.234-1.254-1.234Zm-.074 10.496H1.328V5.165h9.344v6.528Zm0-7.845H1.328v-1.05c0-.146.12-.275.277-.275h8.8c.147 0 .276.12.276.276v1.05h-.01Z" })));
exports.DateIcon = DateIcon;
